import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import Button from '@UI/Button';
import maskSalary from 'maskSalary';
import t from 'prop-types';
import { useAppContext } from 'appContext';

function SearchStickyMobile({ intl, searchParams }) {
  const {
    occupation, city, region, salary,
  } = searchParams;
  const { currencySettings: { currencySign, salarySeparator } } = useAppContext();
  const [headerBottom, setHeaderBottom] = useState(0);
  const [currentSalary, setCurrentSalary] = useState(0);

  /**
   * Scroll to the top of the page.
   */
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  /**
   * Update salary in useEffect to prevent render difference between Server and Client sides.
   */
  useEffect(() => {
    setCurrentSalary(salary);
  }, [salary]);

  /**
   * Set the bottom header side value.
   */
  useEffect(() => {
    const headerEl = document.querySelector('.header__content').getBoundingClientRect();
    setHeaderBottom(headerEl.bottom);
  }, []);

  /**
   * Add window scroll listener.
   */
  useEffect(() => {
    if (!headerBottom) return;

    /**
     * Handle sticky CSS class on page scroll.
     */
    const isStickyHeader = () => {
      const scrollTop = window.scrollY;
      const stickyInfo = document.querySelector('.header-info-mobile');
      if (scrollTop >= headerBottom) {
        // Make sure that we update class once.
        if (!stickyInfo.classList.contains('is-sticky')) {
          stickyInfo.classList.add('is-sticky');
        }
      } else {
        stickyInfo.classList.remove('is-sticky');
      }
    };

    window.addEventListener('scroll', isStickyHeader);
  }, [headerBottom]);
  const backgroundColor = process.env.REACT_APP_BRAND_GUIDELINES === 'true' ? 'bg-variant-brand-primary' : 'bg-variant-brand-secondary';
  return (
    <div
      className={`header-info-mobile hidden--from-l ${process.env.REACT_APP_COUNTRY === 'sph' ? 'bg-brand--gradient-orange' : backgroundColor}`}
      data-testid="search-sticky-mobile"
    >
      <p className="header-info-mobile__text">
        <span className="header-info-m__text--occupation">
          {`${occupation}. `}
        </span>
        {(city && region) && (
          <span className="header-info-m__text--location">
            {`${city}, ${region}. `}
          </span>
        )}
        {currentSalary && currencySign}
        {maskSalary(currentSalary, salarySeparator)}
      </p>
      <Button
        type="filled"
        size="s"
        color="blue"
        onClick={scrollToTop}
      >
        {intl.formatMessage({ id: 'Form.ChangeSalary' })}
      </Button>
    </div>
  );
}

SearchStickyMobile.propTypes = {
  searchParams: t.shape({
    occupation: t.string,
    region: t.string,
    city: t.string,
    salary: t.string,
  }).isRequired,
};

export default injectIntl(SearchStickyMobile);
